import { request } from './request';

export const authApi = {
  login: (username, password, slug) =>
    request('/api/auth/login', { method: 'POST', body: JSON.stringify({ username, password, slug }) }),
};